// Μονοπάτι που ξεκινά με ΜΙΑ κάθετο, δεν συνεχίζει με δεύτερη ή με ανάστροφη, και δεν
// περιέχει ανάστροφη πουθενά. Το «//example.org» είναι διεύθυνση σχετική ως προς το
// πρωτόκολλο και οδηγεί εκτός εφαρμογής· το «/\example.org» καταλήγει στο ίδιο, επειδή
// αρκετοί περιηγητές εξομοιώνουν την ανάστροφη με κάθετο. Απόλυτη διεύθυνση με σχήμα
// («https://…») απορρίπτεται από την αρχική κάθετο.
const INTERNAL_PATH = /^\/(?![/\\])[^\\]*$/;

// Ο προορισμός μετά τη σύνδεση προέρχεται από τη διεύθυνση που ζήτησε ο χρήστης πριν τον
// ανακατευθύνει το RequireAuth, δηλαδή από είσοδο που ελέγχει όποιος του στείλει έναν
// σύνδεσμο. Χωρίς έλεγχο πρόκειται για ανοιχτή ανακατεύθυνση, και μάλιστα ιδιαίτερα
// πειστική: ο χρήστης μόλις συνδέθηκε επιτυχώς στη δική μας εφαρμογή όταν φεύγει προς την
// ξένη σελίδα.
//
// **Πού βρίσκεται η άμυνα.** Ο έλεγχος εφαρμόζεται σε **δύο** σημεία, και η σειρά έχει
// σημασία:
//
//   1. Στο `RequireAuth`, όταν η διεύθυνση **συλλαμβάνεται**. Είναι το όριο εμπιστοσύνης:
//      από εκεί και πέρα το `state.from` δεν είναι πλέον είσοδος του χρήστη.
//   2. Στο `LoginPage`, όταν **καταναλώνεται**. Δεύτερο στρώμα, ώστε ένα `state.from` που
//      θα έμπαινε από άλλη διαδρομή — χειροκίνητο `navigate`, ή οθόνη που θα προστεθεί
//      αργότερα — να μη μπορεί να το παρακάμψει.
//
// Στην αρχική υλοποίηση υπήρχε **μόνο** το δεύτερο. Δεν ήταν ευπάθεια, γιατί το
// `RequireAuth` είναι η μόνη πηγή του `state.from` σήμερα, αλλά η άμυνα βρισκόταν στον
// καταναλωτή αντί στο όριο, δηλαδή εξαρτιόταν από το να μη προστεθεί δεύτερη πηγή.
//
// Ο έλεγχος είναι δικός μας και όχι της βιβλιοθήκης δρομολόγησης σκόπιμα: το πρόβλημα
// είναι ότι εμπιστευόμαστε την είσοδο, και υπάρχει ανεξάρτητα από την έκδοση του router.
// Η ανάστροφη κάθετος είναι ο φορέας της παράκαμψης του CVE-2025-68470, που αφορά
// **ολόκληρη** τη γραμμή 6 του react-router και δεν διορθώνεται με αναβάθμιση μέσα σε αυτή.
export function internalPathOf(from) {
    const pathname = typeof from === 'string' ? from : from?.pathname;

    if (typeof pathname !== 'string' || !INTERNAL_PATH.test(pathname)) return '/';

    return from;
}

export default internalPathOf;
